import { render, staticRenderFns } from "./ProdSidebarItem.vue?vue&type=template&id=2a1ba0f4&"
import script from "./ProdSidebarItem.vue?vue&type=script&lang=js&"
export * from "./ProdSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./ProdSidebarItem.vue?vue&type=style&index=0&id=2a1ba0f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports